// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomEmpty_root__2QMe_","icon":"CustomEmpty_icon__Br3jD","bottomM":"CustomEmpty_bottomM__EC-i4"};